import {isMobileDevice} from "./utils.esm";

export default class TopDestacadoBadge {
    constructor() {
        if(!window.categories) return; // when theres no results in `/search`

        this.categories = window.categories;
        this.init();
        window.addEventListener('scroll', this.topBadgeScrollHandler.bind(this));
    }

    init() {
        if(
            !document.querySelector('#listingCityEscort') ||
            typeof this.categories === 'undefined'
        ) return;

        this.breakpoints = [];

        const categorySlug = document.querySelector('.list_item[class*="category-"]')
            ?.className.split(' ')
            .find((slug) =>
                slug.includes('category-') ?? false
            ).replace('category-', '');

        const currentCategory = Object.values(this.categories)
            .find(category => category.short_name.toLowerCase() === categorySlug ?? false);

        this.createTopBadgeElements(currentCategory);
    }

    createTopBadgeElements(category) {
        if(!category)
            category = this.categories.basic;

        document.querySelectorAll('.list-top-badge, #list-top-badge-ref')
            .forEach(topBadgeRef => topBadgeRef.remove());

        const listTopBadge = document.createElement('div');
        listTopBadge.classList.add('list-top-badge');
        listTopBadge.innerHTML = category.short_name;
        listTopBadge.style.background = category.color;

        const breadcrumbContainer = document.querySelector('#basicSection .fichas-container');
        if(!breadcrumbContainer) return; // pushover

        breadcrumbContainer.classList.add('list-top-badge-container');

        const refPoint = document.createElement('div');
        refPoint.id = 'list-top-badge-ref';

        const container = document.querySelector('[data-product-type]');
        breadcrumbContainer.insertBefore(listTopBadge, container);
        breadcrumbContainer.insertBefore(refPoint, container);
    }

    getCategoryBreakpoints() {
        this.breakpoints = [];
        try {
            Object.values(this.categories).forEach((category) => {
                let selector = '.category-' + category.short_name.toLowerCase();
                if(category.short_name === 'BASIC') selector += ', .list_item:not([class*="category-"])';
                const items = document.querySelectorAll(selector);
                if(items.length === 0)  return;

                let breakpointItem;
                Array.from(items).forEach(item => {
                    const itemDistanceTop = item.getBoundingClientRect().top + window.scrollY;
                    const itemDistanceBottom = items[items.length -1].getBoundingClientRect().bottom + window.scrollY;

                    const samePosition = this.breakpoints.find((breakpoint) => {
                        if(breakpoint.breakpointBottom > itemDistanceTop) return true;
                    });

                    if(!samePosition && !breakpointItem) breakpointItem = {
                        itemDistanceTop,
                        itemDistanceBottom,
                    };
                });

                if(!breakpointItem) return false;
                this.breakpoints.push({
                    category: category,
                    breakpointTop: breakpointItem.itemDistanceTop,
                    breakpointBottom: breakpointItem.itemDistanceBottom,
                });
            });
        } catch(e) {
            throw new Error('Categories not defined');
        }
    }

    topBadgeScrollHandler() {
        this.getCategoryBreakpoints();

        // We define the elements to check if null since theres was errors in pushover
        const headerEl = document.querySelector('header');
        const filterSectionEl  = document.querySelector('#filtersSection');
        if(!headerEl || !filterSectionEl) return; // pushover

        const distance = window.scrollY + (!isMobileDevice ? headerEl.clientHeight + filterSectionEl.clientHeight : 0);
        let breakpoint;
        this.breakpoints.forEach((item) => {
            if(distance >= item.breakpointTop) breakpoint = item;
        });
        const topBadgeEl = document.querySelector('.list-top-badge');
        if(!topBadgeEl) return;
        const posTopSelector = isMobileDevice ? 'pos-top' : 'pos-top-desktop';
        if(breakpoint) {
            topBadgeEl.classList.add(posTopSelector);
            const container = document.querySelector('.list-top-badge');
            container.classList.add('list-top-badge');
            container.innerHTML = breakpoint.category.short_name;
            container.style.background = breakpoint.category.color;
        } else {
            topBadgeEl.classList.remove(posTopSelector);
        }
    }


}